module.exports = "/assets/back.svg";